<div class="container-fluid">
  <ngx-spinner
    bdColor="rgba(100,112,124,0.56)"
    size="medium"
    color="#233547"
    type="ball-clip-rotate-multiple"
    [fullScreen]="true"
  >
    <p style="color: white"></p>
  </ngx-spinner>
  <div class="row pt-2 w-100 mx-0">
    <div class="col-9">
      <div class="header-infos">
        <p
          class="m-0 text-uppercase"
          style="font-size: 20px; color: #262756; font-weight: bold"
        >
          Configuration des alarmes
        </p>
        <small class="text-uppercase" style="font-size: 15px; color: #707070"
          >liste des manoeuvres</small
        >
      </div>
    </div>
    <div class="col-3">
      <div class="row" style="justify-content: end">
        <button
          mat-button
          (click)="openDialogAddEvent()"
          style="
            font-size: 16px;
            margin-right: 1%;
            color: white;
            background-color: #51b373;
            border: none;
            height: 45px;
          "
        >
          EVENEMENTS
          <mat-icon style="color: white">add_circle_outline</mat-icon>
        </button>
        <button
          mat-button
          (click)="openDialog()"
          style="
            font-size: 16px;
            margin-left: 1%;
            background-color: #51b373;
            color: white;
            border: none;
            height: 45px;
          "
        >
          ACCIDENTS
          <mat-icon style="color: white">add_circle_outline</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div>
    <hr />
  </div>
  <div class="col-md-12" style="margin-top: 32px !important">
    <p
      class="m-0 text-uppercase"
      style="font-size: 20px; color: #262756; font-weight: bold"
    >
      alarmes d'accidents
    </p>
  </div>
  <div class="row pt-4 w-100 mx-0">
    <div class="col-2">
      <div class="export-icons d-flex mb-2">
        <div class="icn-sec">
          <img
            (click)="exportExcel(exportDirective, 'xlsx')"
            src="assets/newImages/excel-svg.svg"
            ngbTooltip="Expoter EXCEL"
          />
        </div>
        <div class="icn-sec">
          <img
            (click)="exportTable()"
            src="assets/newImages/pdf-svg.svg"
            ngbTooltip="Expoter PDF"
          />
        </div>
      </div>
    </div>
    <div class="col-1 pl-0">
    </div>
    <div class="col-1 pl-0 pr-md-0 mb-md-2" style="margin-left: 93px">
    </div>
  </div>
  <div class="row ">
    <div class="col-2" style="height: 63px;">

    </div>
    <div class="col-10 w-100"  style="display:flex ;
     justify-content: end; right: 20px;">
      <div
      *ngIf="selection.selected.length >1"
      (click)="supprimerAlarme('moreThanOne',null)"
        class="mat-form-field"
        placement="left"
        ngbTooltip="Supprimer plusieurs alarmes d'accidents"
        style="
          height: 63px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 63px;
        "
      >
        <mat-icon style="font-size: 25px; padding: 0 !important"
          >delete_forever</mat-icon
        >
      </div>
    </div>
  </div>
  <div class="col-md-12" style="margin-top: 29px !important">
    <div class="example-container mat-elevation-z8">
      <ngx-spinner
        *ngIf="spinnerActive != false"
        bdColor="rgba(100,112,124,0.56)"
        size="medium"
        color="#233547"
        type="ball-clip-rotate-multiple"
        [fullScreen]="false"
      >
        <p style="color: white"></p>
      </ngx-spinner>
      <table
        mat-table
        class="w-100"
        #exportDirective="matTableExporter"
        matTableExporter
        [dataSource]="dataSource"
        matSort
      >
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef></th>
          <td
            (click)="selection.toggle(element)"
            mat-cell
            *matCellDef="let element"
          >
            <mat-checkbox
              disabled
              (change)="$event ? selection.toggle(element) : null"
              [checked]="selection.isSelected(element)"
              [aria-label]="checkboxLabel(element)"
            >
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>ID.</th>
          <td
            (click)="selection.toggle(element)"
            mat-cell
            *matCellDef="let element"
            (contextmenu)="onContextMenu($event, element)"
          >
            {{ element?.id }}
          </td>
        </ng-container>
        <ng-container matColumnDef="created_by">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
          <td
            (click)="selection.toggle(element)"
            mat-cell
            *matCellDef="let element"
            (contextmenu)="onContextMenu($event, element)"
          >
            {{ element?.created_by }}
          </td>
        </ng-container>
        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Date de création
          </th>
          <td
            (click)="selection.toggle(element)"
            mat-cell
            *matCellDef="let element"
            (contextmenu)="onContextMenu($event, element)"
          >
            {{ element?.created_at | date:'dd/MM/yyyy H:mm:ss' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="updated_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Date de modification
          </th>
          <td
            (click)="selection.toggle(element)"
            mat-cell
            *matCellDef="let element"
            (contextmenu)="onContextMenu($event, element)"
          >
            {{ element?.updated_at | date:'dd/MM/yyyy H:mm:ss' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Actions</th>
          <td (click)="selection.toggle(element)" mat-cell *matCellDef="let element" >
            <img
              [ngClass]="{disable:selection.selected.length>1}"
              (click)="afficher_info(element)"
              placement="left"
              ngbTooltip="Détails d'alarme"
              src="assets/icons/icon-details.svg"
            />
            <img
              [ngClass]="{disable:selection.selected.length>1}"
              (click)="modifierAlarme('oneItem',element.id ,element )"
              placement="left"
              ngbTooltip="Modifier"
              src="assets/icons/icon-modifier.svg"
            />
            <a
            [ngStyle]="{'pointer-events': selection.selected.length>1 ? 'none' : 'all'
           , 'opacity':selection.selected.length >1 ?'0.5' : '1'}"
            >

             <img
             [ngClass]="{disable:selection.selected.length>1}"
             placement="left"
             ngbTooltip="Supprimer {{ element.filter_name }}"
             src="assets/icons/icon-delete.svg"
             (click)="supprimerAlarme('oneItem',element.id)"/></a>

          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumns"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="12">
            Aucune donnée correspondante à votre recherche
          </td>
        </tr>
      </table>
      <mat-paginator
        #paginator
       [pageSize]="15"
       (page)="pageChanged($event)"
       [pageSizeOptions]="[15, 30, 100]"
       showFirstLastButtons
      >
      </mat-paginator>
    </div>
  </div>
  <div class="col-md-12" style="margin-top: 32px !important">
    <p
      class="m-0 text-uppercase"
      style="font-size: 20px; color: #262756; font-weight: bold"
    >
      alarmes d'Evenements
    </p>
  </div>
  <div class="col-md-12" style="margin-top: 29px !important">
    <listeAlarmEvents></listeAlarmEvents>
  </div>
</div>
<br /><br />
